export enum SocialAccountType {
  Instagram = "Instagram",
  InstagramPersonal = "InstagramPersonal",
  FacebookPage = "FacebookPage",
  FacebookGroup = "FacebookGroup",
  LinkedInCompany = "LinkedInCompany",
  LinkedInPersonal = "LinkedInPersonal",
  GoogleMyBusiness = "GoogleMyBusiness",
  Twitter = "Twitter",
  Youtube = "Youtube",
  Pinterest = "Pinterest",
  PinterestV3 = "PinterestV3",
  TikTok = "TikTok",
  ThreadsNotification = "ThreadsNotification",
  ThreadsConnect = "ThreadsConnect",
  Snapchat = "Snapchat",
  Other = "Other",
}
